import React, { PropsWithChildren } from 'react';
import { PropsWithLocation } from '@model';
import { Footer, Header, ReviewWidgetFloating, YoshikiFrame } from '@src/components';

import '@styles/main.scss';

import './FormPage.scss';
import mail from '@images/mail.svg';

export interface FormPagesLayoutProps extends PropsWithLocation {
  classNames?: string;
  reviews?: boolean;
  getInTouchTop?: boolean;
  getInTouchBottom?: boolean;
  yoshikiFrame?: boolean;
  yoshiBg?: boolean;
}

export function FormPage(props: PropsWithChildren<FormPagesLayoutProps>) {
  const { yoshikiFrame, yoshiBg, getInTouchTop, getInTouchBottom, children, classNames, location, reviews } = props;

  return (
    <>
      <Header className={classNames} />
      <main className={`form-page ${classNames || ''}`}>
        <div className='form-page-container form-page-container-typography form-page-container-utility'>{children}</div>
      </main>
      {getInTouchTop && (
        <div className='get-in-touch'>
          <h1>
            GET IN <span>TOUCH</span>
          </h1>
          <div className='get-in-touch-copy'>
            <img src={mail} alt='Mail' />
            <div>
              <h2>Email Us</h2>
              <a href='mailto: hello@theclaimsguyslegal.com'>hello@theclaimsguyslegal.com</a>
            </div>
          </div>
        </div>
      )}
      {reviews && (
        <div>
          <h2 className='review-io-heading'>What Our Customers Think</h2>
          <ReviewWidgetFloating internalId={'1'} />
        </div>
      )}
      {getInTouchBottom && (
        <div className='get-in-touch'>
          <h1>
            GET IN <span>TOUCH</span>
          </h1>
          <div className='get-in-touch-copy'>
            <img src={mail} alt='Mail' />
            <div>
              <h2>Email Us</h2>
              <a href='mailto: hello@theclaimsguyslegal.com'>hello@theclaimsguyslegal.com</a>
            </div>
          </div>
        </div>
      )}
      {yoshikiFrame && (
        <div className={yoshiBg ? 'yoshiki-bg-grey' : ''}>
          <YoshikiFrame />
        </div>
      )}
      <Footer location={location} className={classNames} />
    </>
  );
}
